import React, { Component } from "react";
import Routes from "./routes";
import ErrorPage from "views/errors/server-error";
import MailTo from "components/modules/mailto";

class App extends Component {
    constructor(props) {
        super(props);
        this.state = { haseError: false, errorInfo: null };
    }
    
    componentDidMount() {
        localStorage.removeItem("wantedReportType")
        localStorage.removeItem("wantedVariable1")
       localStorage.removeItem("wantedVariable2")
       localStorage.removeItem('wantedChartCode')
    }

    static getDerivedStateFromError(error) {
        return { haseError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log error details for debugging
        console.error("Error caught by Error Boundary:", error);
        console.error("Error Info:", errorInfo);
        this.setState({ errorInfo });
    }

    resetError = () => {
        this.setState({ haseError: false, errorInfo: null });
    }
    render() {
        
        const { declineCookiePolicyPrompt } = localStorage;
        if (declineCookiePolicyPrompt === "true") {
            if(!document.__defineGetter__) {
                Object.defineProperty(document, 'cookie', {
                    get: function(){return ''},
                    set: function(){return true},
                });
            } else {
                document.__defineGetter__("cookie", function() { return '';} );
                document.__defineSetter__("cookie", function() {} );
            }
        }
        if (this.state.haseError) {
            return <ErrorPage onReset={this.resetError} />;
        }

        return <Routes />;
    }
}

export default App;
